import { inject, Injectable } from '@angular/core';

import { distinctUntilChanged, filter, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { AppState } from '@fcom/core';
import { pseudoLocal } from '@fcom/core/selectors/pseudo-local.selector';
import * as PseudoLocalActions from '@fcom/core/actions/pseudo-local.actions';
import { isPresent } from '@fcom/core/utils/utils';
import { finShare } from '@fcom/rx/operators/finShare';

/**
 * Note! This is service meant to be provided by TabHeaderComponent and TabGroupComponent
 * for their child components to share data. Therefore DO NOT add this to any other provider!
 */
@Injectable()
export class TabStateService {
  private store$ = inject<Store<AppState>>(Store);

  private selectedTabId$: Observable<string> = of(null);
  private tabGroupId: string;

  init(tabGroupId: string): void {
    this.tabGroupId = tabGroupId;
    this.selectedTabId$ = this.store$.pipe(
      pseudoLocal(this.tabGroupId),
      filter((id: string) => isPresent(id)),
      distinctUntilChanged(),
      finShare()
    );
  }

  clear(): void {
    this.store$.dispatch(PseudoLocalActions.destroyValue({ key: this.tabGroupId }));
  }

  getSelectedTabId(): Observable<string> {
    return this.selectedTabId$;
  }

  setSelectedTabId(tabId: string): void {
    if (tabId) {
      this.store$.dispatch(PseudoLocalActions.setValue({ key: this.tabGroupId, data: tabId }));
    } else {
      this.clear();
    }
  }
}
